import React from "react"
import { UniversalLink } from "../UniversalLink"
import "./header.scss"
import { homeNavigation, navigation } from "./navigation"
import { NavLink } from "./NavLink"

export const Header = () => (
  <header className="header">
    <div className="flex-[3]">
      <NavLink nav={homeNavigation} className="logo" />
    </div>

    <input className="side-menu" type="checkbox" id="side-menu" />
    <label className="mobile-menu-toggle" htmlFor="side-menu">
      <span className="mobile-menu-line" />
    </label>

    <nav className="nav">
      <ul className="menu">
        {navigation.map((nav) => (
          <li key={nav.name} className={`menu-`.concat(nav.key)}>
            <NavLink nav={nav} />
          </li>
        ))}
        <li key="apply" className="menu-apply">
          <UniversalLink
            className="btn btn-primary btn-fixed"
            to="https://submit.xrplgrants.org/submit"
          >
            <span>Apply&nbsp;Now</span>
            <span className="arrow">&#10132;</span>
          </UniversalLink>
        </li>
      </ul>
    </nav>
  </header>
)
